const palette = {
  primary: {
    main: "#3BDFCF",
  },
};

export default palette;
